export const intlKey: unique symbol = Symbol()
